import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, effect, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Route, Router, RouterModule } from '@angular/router';
import { TablerIconComponent } from 'angular-tabler-icons';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { PanelMenu } from 'primeng/panelmenu';
import { TooltipModule } from 'primeng/tooltip';
import { SIDE_MENU_CONSTANTS } from './sidemenu-constants';
import { SidebarService } from '../../services/sidebar.service';
import { KeycloakService } from '../../../../../../usermgmt/src/lib/services/keycloak.service';
import { AppStateService } from 'usermgmt';
import { isPlatformBrowser } from '@angular/common';
import { filterAccessibleMenuItems } from '../../utils/application-permission.util';
import { MenuModule } from 'primeng/menu';
import { CommonService } from '../../services/common.service';
import { HttpServiceService } from '../../services/http-service.service';
import { environment } from '../../../../environments/environment';
import { filter } from 'rxjs';

@Component({
  selector: 'app-sidemenu',
  imports: [
    CommonModule,
    RouterModule,
    AvatarModule,
    ButtonModule,
    PanelMenu,
    BadgeModule,
    TablerIconComponent,
    TooltipModule,
    MenuModule
  ],
  templateUrl: './sidemenu.component.html',
  styleUrl: './sidemenu.component.scss'
})

export class SidemenuComponent implements OnInit, AfterViewInit {

  private isBrowser: boolean;
  items: MenuItem[] = JSON.parse(JSON.stringify(SIDE_MENU_CONSTANTS.MENU_ITEMS));
  queryParams: any;
  isCollapsed = false;
  isAccessDenied = false;
  hasResourcesAccess: boolean = false;
  hasNavigated: boolean = false;
  userMenuItems: any;

  isMobileView: boolean = false;
  lastLoginTime: string = '';


  constructor(
    private sidebarService: SidebarService,
    private keycloakService: KeycloakService,
    private appStateSrv: AppStateService,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private httpservice: HttpServiceService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {

    this.isBrowser = isPlatformBrowser(this.platformId);

    this.sidebarService.sidebarState$.subscribe((state) => {
      this.isCollapsed = state;
    });

    effect(() => {
      this.isMobileView = this.commonService.getIsMobile();
      if (this.isBrowser && this.isMobileView) {
        this.initMethod();
      }
    });
  }

  ngOnInit() {
    this.subscribeRouterEvents()
    if (this.isBrowser) {
      this.fetchLastLoginTime();
    }
  }

  ngAfterViewInit(): void {
    // this.loadDisasterBadges();
  }

  loadDisasterBadges() {
    // imagine service returns an object: { shelter: 2, winds: 1, rainfall: 3, lightning: 0, parentTotal: 6 }
    let url = environment.url.AWARE_DISASTER_URL;
    let endpoint = 'analytics/alert-user-location-counts';
    this.httpservice.get(endpoint, url, true).subscribe((response: any) => {
      // Find Disaster Management parent
      const dm = this.items.find(i => i.label === 'Disaster Management');
      if (!dm) return;

      // Filter only "ALERT ADMIN" items
      //    response = [
      //   { label: 'RAINFALL ALERT ADMIN', locationCount: 3 },
      //   { label: 'WIND ALERT ADMIN', locationCount: 2 },
      //   { label: 'LIGHTNING ALERT ADMIN', locationCount: 1 },
      //   { label: 'HEAT ALERT ADMIN', locationCount: 0 }
      // ];
      const alertAdminItems = response.filter((item: any) =>
        item.label.includes('ALERT') && item.label.includes('ADMIN')
      );

      // Helper function to sum userCount for matching labels
      const sumUserCounts = (keyword: string): number => {
        return alertAdminItems
          .filter((item: any) => item.label.toUpperCase().includes(keyword.toUpperCase()))
          .reduce((sum: any, item: any) => sum + item.locationCount, 0);
      };

      // Calculate counts for each category
      const counts: any = {
        rainfall: sumUserCounts('RAINFALL'),
        winds: sumUserCounts('WIND'),
        lightning: sumUserCounts('LIGHTNING'),
        heatwave: sumUserCounts('HEAT'),
        shelter: 0 // Add your logic for shelter if needed
      };

      // Calculate parent total from the four main categories
      counts.parentTotal = counts.rainfall + counts.winds + counts.lightning + counts.heatwave;

      // Update parent badge
      dm.badge = counts.parentTotal > 0 ? String(counts.parentTotal) : '';

      // Update children badges
      const mapByLabel = (label: string) => dm.items?.find((c: any) => c.label === label);

      const shelter = mapByLabel('Shelter Management');
      if (shelter) shelter.badge = counts.shelter ? String(counts.shelter) : '';

      const winds = mapByLabel('Winds');
      if (winds) winds.badge = counts.winds > 0 ? String(counts.winds) : '';

      const rainfall = mapByLabel('Rainfall');
      if (rainfall) rainfall.badge = counts.rainfall > 0 ? String(counts.rainfall) : '';

      const heatwave = mapByLabel('Heatwave Advisory');
      if (heatwave) heatwave.badge = counts.heatwave > 0 ? String(counts.heatwave) : '';

      const lightning = mapByLabel('Lightning');
      if (lightning) lightning.badge = counts.lightning > 0 ? String(counts.lightning) : '';
    });



  }

  initMethod() {
    // this.loadDisasterBadges();
     if (this.router.url.includes('/access-denied')) {
        this.isAccessDenied = true;
    } else {
        this.isAccessDenied = false;
    }
    if (this.isBrowser) {
      const userPermissionsString: any = localStorage.getItem('userPermissions');

      const userInfoStr = localStorage.getItem('userInfo');

      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        const userName = userInfo.firstName + userInfo.lastName;

        this.userMenuItems = [
          {
            label: userName,
            items: [
              {
                label: this.lastLoginTime ? `Last Login: ${this.lastLoginTime}` : `Last Login: -`,
                icon: 'pi pi-clock',
                disabled: !this.lastLoginTime
              },
              { separator: true },
              {
                label: 'Logout',
                icon: 'pi pi-sign-out',
                command: () => this.logOut()
              }
            ]
          }
        ];
      }


      if (userPermissionsString) {
        this.items = filterAccessibleMenuItems(
          SIDE_MENU_CONSTANTS.MENU_ITEMS,
          userPermissionsString,
          { isMobileView: this.isMobileView }
        );
        this.hasResourcesAccess = this.items.length > 0;
      } else {
        this.items = filterAccessibleMenuItems(SIDE_MENU_CONSTANTS.MENU_ITEMS, {}, { isMobileView: this.isMobileView });
        this.hasResourcesAccess = this.items.length > 0;
      }
    }
  }

  fetchLastLoginTime() {
    let endpoint = 'last-login-time';
    this.httpservice.getUMData(endpoint).subscribe({
      next: (result: any) => {
        const response = result['response'];
        if (response && response['lastLoginTime']) {
          this.lastLoginTime = this.formatISTTimeStamp(response['lastLoginTime']);
          this.updateLastLoginItem();
        }
      },
      error: (error: any) => {
        console.error('Failed to fetch last login time:', error);
      }
    });
  }

  updateLastLoginItem() {
    if (this.userMenuItems && this.userMenuItems[0] && this.userMenuItems[0].items && this.userMenuItems[0].items.length > 0) {
      this.userMenuItems[0].items[0].label = `Last Login: ${this.lastLoginTime}`;
      this.userMenuItems[0].items[0].disabled = false;
    }
  }

  formatISTTimeStamp(timestamp: string | number | Date): string {
    return new Date(timestamp).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  }



  subscribeRouterEvents() {
    this.route.queryParams.subscribe((params: any) => {
      this.initMethod();
    });
    // this.router.events.subscribe((routes: any) => {
    //   this.initMethod();
    // });

    this.router.events
        .pipe(
            filter((event) => event instanceof NavigationEnd)
        )
        .subscribe((event: NavigationEnd) => {

            this.isAccessDenied =
                event.urlAfterRedirects.includes('/access-denied');

        });
  }

  toggleItem(item: any): void {
    if (item['items']?.length) {
      item['expanded'] = !item['expanded'];
    }
  }




  toggleAll() {
    const expanded: any = !this.areAllItemsExpanded();
    this.items = this.toggleAllRecursive(this.items, expanded);
  }

  private toggleAllRecursive(items: MenuItem[], expanded: boolean): MenuItem[] {
    return items.map((menuItem: any) => {
      menuItem.expanded = expanded;
      if (menuItem.items) {
        menuItem.items = this.toggleAllRecursive(menuItem.items, expanded);
      }
      return menuItem;
    });
  }

  private areAllItemsExpanded(): boolean {
    return this.items.every((menuItem: any) => menuItem.expanded);
  }



  navigateToRoute(route: string) {
    // this.router.navigate([route]);
    this.router.navigate([route]).then(success => {
    }).catch(err => {
    });

  }


  toggleSidebar() {
    this.sidebarService.toggleSidebar();
  }

  logOut() {
    this.keycloakService.logout()
  }

  closeSidebar() {
    this.sidebarService.toogleSidebarMobileView()
  }

  navigateToLanding() {
    this.router.navigate(['/landing']);
    this.closeSidebar();
  }
}
